import { Button, Checkbox } from '@aqarmap/aqarmap-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '~/components/Modal';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import { skipMainAccountConfirm } from '~addListing/utils/SessionStorage';

export default function MainAccountConfirmModal({
  fees,
  isLoading,
  onConfirm,
}: {
  fees: number;
  isLoading: boolean;
  onConfirm: () => void;
}) {
  const { t } = useTranslation('app');
  const dispatch = useAppDispatch();
  const [isDontShowAgain, setIsDontShowAgain] = useState(false);

  const onCancel = () => {
    setIsDontShowAgain(false);
    dispatch(closeModal('mainAccountConfirmModal'));
  };

  return (
    <Modal
      modalKey="mainAccountConfirmModal"
      title={t('publishListing')}
      Footer={
        <div className="flex w-full gap-x sm:pb-x">
          <Button
            ariaLabel="confirm-main-account-publish"
            size="medium"
            variant="primary"
            className="w-full whitespace-nowrap"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={() => {
              if (isDontShowAgain) skipMainAccountConfirm();
              onConfirm();
            }}
          >
            {t('publishAccountPayNow')}
          </Button>
          <Button
            ariaLabel="cancel-main-account-publish"
            size="medium"
            variant="secondary"
            className="w-full"
            disabled={isLoading}
            onClick={onCancel}
          >
            {t('cancel')}
          </Button>
        </div>
      }
      bodyClassName="!py-3x"
    >
      <div className="flex flex-col gap-3x">
        <div className="flex flex-col gap-0.5x">
          <p className="text-body-1 text-black">
            {t('mainAccountConfirmCredits', { credits: fees ?? 0 })}
          </p>
          <p className="text-caption-1 text-gray__dark_1">
            {t('mainAccountConfirmDesc')}
          </p>
        </div>
        <Checkbox
          label={{
            text: t('dontShowAgainThisSession'),
            className: 'text-body-2 text-gray__dark_2',
          }}
          size="medium"
          wrapperClassName="!gap-1.5x"
          field={{
            id: 'dontShowAgainThisSession',
            name: 'dontShowAgainThisSession',
            checked: isDontShowAgain,
            onChange: (e) => setIsDontShowAgain(e.target.checked),
          }}
        />
      </div>
    </Modal>
  );
}
